/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserSecurityClearanceResponse } from './UserSecurityClearanceResponse';
import {
    UserSecurityClearanceResponseFromJSON,
    UserSecurityClearanceResponseFromJSONTyped,
    UserSecurityClearanceResponseToJSON,
    UserSecurityClearanceResponseToJSONTyped,
} from './UserSecurityClearanceResponse';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Paginated user security clearance list response
 * @export
 * @interface UserSecurityClearanceListResponse
 */
export interface UserSecurityClearanceListResponse {
    /**
     * 
     * @type {string}
     * @memberof UserSecurityClearanceListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof UserSecurityClearanceListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof UserSecurityClearanceListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof UserSecurityClearanceListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * List of user security clearances
     * @type {Array<UserSecurityClearanceResponse>}
     * @memberof UserSecurityClearanceListResponse
     */
    data?: Array<UserSecurityClearanceResponse>;
    /**
     * Total number of security clearances
     * @type {number}
     * @memberof UserSecurityClearanceListResponse
     */
    total?: number;
    /**
     * Current page number
     * @type {number}
     * @memberof UserSecurityClearanceListResponse
     */
    page?: number;
    /**
     * Number of clearances per page
     * @type {number}
     * @memberof UserSecurityClearanceListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the UserSecurityClearanceListResponse interface.
 */
export function instanceOfUserSecurityClearanceListResponse(value: object): value is UserSecurityClearanceListResponse {
    return true;
}

export function UserSecurityClearanceListResponseFromJSON(json: any): UserSecurityClearanceListResponse {
    return UserSecurityClearanceListResponseFromJSONTyped(json, false);
}

export function UserSecurityClearanceListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSecurityClearanceListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UserSecurityClearanceResponseFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function UserSecurityClearanceListResponseToJSON(json: any): UserSecurityClearanceListResponse {
    return UserSecurityClearanceListResponseToJSONTyped(json, false);
}

export function UserSecurityClearanceListResponseToJSONTyped(value?: UserSecurityClearanceListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UserSecurityClearanceResponseToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

